import react from 'react';

import { addComma } from 'constants/utils';
import { ISections } from 'screens/salary_specification/detail/DetailPay';

interface IProps {
  Title: string;
  TableData: ISections[];
  PAYTYPE?: string;
}

const SectionTableDetail = ({ Title, TableData, PAYTYPE = '' }: IProps) => {
  return (
    <div className="DP_SectionTable">
      <strong>{Title}</strong>
      <table>
        <thead>
          <tr>
            <th>항목</th>
            <th>값</th>
          </tr>
        </thead>
        <tbody>
          {TableData.map((item, index) => {
            let TITLE = item.title;
            if (item.title == '기본급' && PAYTYPE == '3') {
              TITLE = `${item.title}(주휴수당포함)`;
            }

            return (
              <tr key={index}>
                {item.title == '기본급' && PAYTYPE == '3' ? (
                  <td>{TITLE}</td>
                ) : item.title == '식대' || item.title == '자가운전보조금' || item.title == '육아수당' ? (
                  <td>{item.title}(비과세)</td>
                ) : (
                  <td>{item.title}</td>
                )}
                <td>{addComma(item.value)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SectionTableDetail;
